import { isSignedIn } from "@culturehq/client";

const useIsLoggedIn = isSignedIn;

export default useIsLoggedIn;
